// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createLinkIconStyles, hideEmpty, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { css } from "styled-components";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconClose from "@vanmeter/XDL/Icons/IconClose";

addToListModalStyles.modal = {
    sizeVariant: "medium",
};

addToListModalStyles.userTableHeaderText = {
    ...fontConfig.xSmall,
    color: "common.white",
};

addToListModalStyles.editingPermissionText = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.bold,
};

addToListModalStyles.editingPermissionRadioGroup = {
    css: css`
        flex-direction: column;
        gap: 8px;
    `,
};

addToListModalStyles.editingPermissionRadio = {
    css: css`
        &&&&& {
            margin: 0;
        }
    `,
};

addToListModalStyles.userRemoveLink = {
    icon: {
        iconProps: {
            src: IconClose,
            size: 10,
        },
    },
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
    },
};

addToListModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

addToListModalStyles.makePrivateButton = {
    ...modalButtonsActionStyles.cancelButton,
};

addToListModalStyles.closeButton = {
    ...modalButtonsActionStyles.submitButton,
};

addToListModalStyles.userCell = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};

addToListModalStyles.usersTableWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: center;
        ${hideEmpty}
    `,
};

addToListModalStyles.sharedWithAllText = {
    ...fontConfig.smallSingleLine,
};

addToListModalStyles.inviteButton = {
    buttonType: "outline",
    css: css`
        margin-left: auto;
    `,
};
